export default "__VITE_ASSET__TlD6rkw2__"